<div class="relative flex flex-col gap-1 justify-between items-start">
  <!-- Mention/context menu -->
  @if (showMentionButton()) {
    <p-menu
      #mentionMenu
      [model]="filteredAgentOptions"
      [popup]="true"
      [styleClass]="
        'z-[1020]' +
        (dark
          ? ' bg-neutral-900 border border-neutral-700 rounded shadow-md text-sm'
          : ' bg-neutral-100 border border-neutral-200 rounded shadow-md text-sm')
      "
      appendTo="body"
    >
      <ng-template
        pTemplate="item"
        let-item
      >
        <a
          [ngClass]="{
            'bg-neutral-700 !text-white': item === filteredAgentOptions[highlightedIndex],
          }"
          (click)="selectMention(item)"
          class="flex align-items-start p-menuitem-link font-thin text-white"
          pRipple
        >
          <i class="ph ph-sparkle text-yellow-400 text-sm mr-1"></i>
          {{ item }}
        </a>
      </ng-template>
    </p-menu>
  }
  @if (showMentionButton()) {
    <div class="flex flex-row items-center gap-2 w-full">
      <div
        (click)="toggleAgentMenu($event)"
        class="flex flex-row items-center cursor-pointer border border-neutral-700 rounded text-neutral-700 hover:bg-neutral-700 hover:text-neutral-200 p-0"
        tabindex="0"
      >
        <i class="ph ph-at text-neutral-200 px-1 py-0.5 text-xs"></i>
        <span class="text-xs text-neutral-200 font-thin pr-1">Agent</span>
      </div>
      <!-- Audit shortcut: visible on Process / UI / UI Flow / Reusable UI Template pages -->
      @if (auditConfig(); as audit) {
        <button
          [attr.aria-label]="audit.label"
          (click)="triggerAudit()"
          class="flex flex-row items-center gap-1 cursor-pointer border border-yellow-600 rounded text-yellow-400 hover:bg-yellow-600 hover:text-neutral-900 px-1 py-0.5"
          tabindex="0"
          type="button"
        >
          <i class="ph ph-shield-check text-xs"></i>
          <span class="text-xs font-thin">{{ audit.label }}</span>
        </button>
      }
      <div
        *ngIf="agentControl.value"
        class="flex gap-2 items-center text-xs"
      >
        <div class="flex items-center gap-1 px-1 py-1 bg-neutral-800 rounded">
          <i class="ph ph-sparkle text-xs mr-1"></i>
          <span class="text-xs">{{ agentControl.value }}</span>
          <i
            (click)="removeMention()"
            class="ph ph-x cursor-pointer ml-1 text-neutral-400 hover:text-neutral-200"
          ></i>
        </div>
      </div>
    </div>
  }

  <div class="flex flex-row gap-1 justify-between items-stretch w-full my-1asda">
    <div class="textarea-wrapper w-full relative">
      <textarea
        #textarea
        [placeholder]="!typeControl.value ? animatedHint : ''"
        [formControl]="typeControl"
        [rows]="1"
        [ngClass]="{
          'max-h-[50px]': !bigger,
          'text-neutral-900': !dark,
          'bg-transparent': dark,
          'scrollbar-dark': dark,
          'bg-neutral-50': !dark,
        }"
        (keydown)="onTextareaKeydown($event)"
        (input)="onTextareaInput($event)"
        class="w-full mr-6 min-h-1 max-h-[120px] textarea-on-top placeholder-unselectable placeholder:px-1 text-sm/6 placeholder-opacity-40 disabled:cursor-not-allowed outline-none"
        flxAutofocus
        cdkTextareaAutosize
      ></textarea>
    </div>
  </div>
  <div class="flex flex-row gap-1 justify-end items-end w-full">
    @if (showUpload() && dark) {
      <button
        [disabled]="isUploadDisabled()"
        (click)="menuCommand.toggle($event)"
        class="w-6 h-6 hover:bg-yellow-600 hover:text-neutral-900 text-neutral-600 hover:text-neutral-900 flex justify-center items-center rounded"
      >
        <p-menu
          #menuCommand
          [model]="items"
          [popup]="true"
          styleClass="z-[1020] absolute bg-neutral-900 border border-neutral-700 rounded shadow-md text-sm"
          appendTo="body"
        >
          <ng-template
            pTemplate="item"
            let-item
          >
            <a
              class="flex align-items-start p-menuitem-link text-white"
              pRipple
            >
              <i [ngClass]="item.icon + ' menu-item-icon text-base text-yellow-400 text-lg'"></i>
              <div class="flex flex-col align-item-center">
                <span class="ml-2 menu-item-name text-white">{{ item.label }}</span>
                <span class="ml-2 menu-item-details">{{ item.description }}</span>
              </div>
            </a>
          </ng-template>
        </p-menu>
        <i class="ph ph-paperclip text-base w-6 h-6"></i>
      </button>

      <input
        #processUpload
        [accept]="allowedProcessFileTypes()"
        [multiple]="isMultipleProcessUploadAllowed()"
        (change)="onFileSelected($event)"
        class="hidden peer"
        type="file"
      />

      <input
        #imageUpload
        [accept]="allowedImageFileTypes()"
        [multiple]="isMultipleImageUploadAllowed()"
        (change)="onFileSelected($event)"
        class="hidden peer"
        type="file"
      />

      <input
        #docUpload
        [accept]="allowedDocumentFileTypes()"
        [multiple]="isMultipleDocumentUploadAllowed()"
        (change)="onFileSelected($event)"
        class="hidden peer"
        type="file"
      />
    }
    <flx-ai-shortcut
      [icons]="submitShortcut"
      [ngClass]="{ 'opacity-30': !canSubmitPrompt() }"
      [pTooltip]="promptInvalidLengthMsg"
      [tooltipDisabled]="!promptInvalidLengthMsg"
      (click)="submitTypeControl()"
      class="group/shortcut flex right-0 cursor-pointer pointer-events-auto"
      tooltipStyleClass="tooltip-error"
      tooltipPosition="top"
    ></flx-ai-shortcut>
  </div>
</div>
